import { Outlet } from "react-router-dom";

const HelpersPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default HelpersPageLayout;